import type { GenerationModeId } from "./marketing-content";

// Original Flowisle line drawings: a swift quill, a composed page, an orbiting star.
export function GenerationModeIcon({ mode }: { mode: GenerationModeId }) {
  return (
    <svg className="generation-mode-icon" data-mode-icon={mode} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      {mode === "fast" ? (
        <>
          <path className="mode-icon-wash" d="M8 16C7 9 12 4 21 3c-1 9-6 14-13 13Z" />
          <path d="M8 16C7 9 12 4 21 3c-1 9-6 14-13 13ZM5 20 17 8m-5 5h5M3 7h4M2 11h3" />
        </>
      ) : mode === "professional" ? (
        <>
          <rect className="mode-icon-wash" x="5" y="3" width="14" height="18" rx="3" />
          <rect x="5" y="3" width="14" height="18" rx="3" />
          <path d="M9 8h6M9 12h6M9 16h3M2 7v10m20-10v10" />
        </>
      ) : (
        <>
          <path className="mode-icon-wash" d="m12 3 2.4 5.6L20 11l-5.6 2.4L12 19l-2.4-5.6L4 11l5.6-2.4Z" />
          <path d="m12 3 2.4 5.6L20 11l-5.6 2.4L12 19l-2.4-5.6L4 11l5.6-2.4Z" />
          <path d="M19 16c2.5.8 3.3 2 2.6 3.1-1.3 1.9-6.6 1.5-11.8-.7M4 6c-2.3-.5-3 .1-2.8 1.2" />
        </>
      )}
    </svg>
  );
}